<template>
  <LeftNav :enabled-nav="enabledReportNavs" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppCoreStore } from "@/src/stores/app-core";
import { PermissionNames } from "@/src/enums";
// @ts-ignore
import LeftNav from "@/src/components/shared/LeftNav.vue";

/**
 * This array controls the items that appear in the left nav.
 * Array contains Objects for each section.
 * {
 *    name: 'Title of the Section', // required
 *    subsections: [ // required. The actual Links to display in the subsection. Each link is an object
 *      {
 *        name: 'Text of the link', // required.
 *        url_path: 'string_name_of_the_vue_router_path', // required.
 *        permission_key: PermissionNames.XXX_YYYY // required. The permission to check if the user has it or not, use PermissionNames enum
 *        check_feature: (settings) > { return BOOLEAN BASED ON FEATURE CHECK } // Optional function to check if a feature should be checked before enabling
 *                                                                              // This link. appStore.applicationSettings are passed to the function.
 *      }
 *    ]
 *
 * }
 */
const OperationalReportsAreaNavs: NavSection[] = [
  {
    name: 'Client Reports',
    sub_sections: [
      {
        name: 'Monthly TxC Reports',
        url_path: 'admin_ops_reports_monthly_txc_reports',
        permission_key: PermissionNames.OPERATIONAL_REPORTS_MONTHLY_TXC_REPORTING,
      }
    ],
  },
  {
    name: 'Admin Reports',
    sub_sections: [
      {
        name: 'Admin Reports',
        url_path: 'operational_reports_admin_reports',
        permission_key: PermissionNames.OPERATIONAL_REPORTS_ADMIN_REPORTING,
      },
    ]
  },
  {
    name: 'Business Reports',
    sub_sections: [
      {
        name: 'Monthly Business Reports',
        url_path: 'operational_reports_monthly_business_reports',
        permission_key: PermissionNames.OPERATIONAL_REPORTS_MONTHLY_BUSINESS_REPORTING,
      },
      {
        name: 'Other Metrics',
        url_path: 'operational_reports_business_other_metrics',
        permission_key: PermissionNames.OPERATIONAL_REPORTS_BUSINESS_OTHER_METRICS,
      }
    ]
  },
];

type NavSubSection = {
  name: string;
  url_path: string;
  permission_key: any;
  enabled?: boolean;
  check_feature?: (settings: any) => boolean;
}

type NavSection = {
  name: string;
  sub_sections: NavSubSection[];
  enabled?: boolean;
}

const appStore = useAppCoreStore();

const user = computed(() => appStore.currentUser);
const userPermissions = computed(() => appStore.currentUser ? appStore.currentUser.userPermissions : null);

const enabledReportNavs = computed(() => {
  if (!user.value || !userPermissions.value) return [];
  return OperationalReportsAreaNavs.map((report_nav) => {
    report_nav.sub_sections.map((sub) => {
      const nav_perm = userPermissions.value[sub.permission_key];
      sub.enabled = nav_perm ? (nav_perm.read || false) : false;
      if (sub.check_feature) {
        // Have permission, but feature disabled, then it will be disabled.
        sub.enabled = sub.check_feature(appStore.applicationSettings) && sub.enabled ? true : false;
      }
      return sub;
    });
    report_nav.enabled = report_nav.sub_sections.some(sub => sub.enabled);
    return report_nav;
  });
});
</script>
